import { render, staticRenderFns } from "./ProductShowcaseVideo.vue?vue&type=template&id=0aea8696&"
import script from "./ProductShowcaseVideo.vue?vue&type=script&lang=js&"
export * from "./ProductShowcaseVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports